import React from 'react';
export function Footer() {
  return <footer className="bg-gray-900 text-white py-8 px-4 mt-16" data-id="element-133">
      <div className="container mx-auto max-w-4xl" data-id="element-134">
        <div className="mb-6" data-id="element-135">
          <p className="text-sm mb-4" data-id="element-136">
            Den här sidan drivs av Decidely i samarbete med Verisure.
          </p>
          <p className="text-sm mb-4" data-id="element-137">
            Vi samlar inte in personuppgifter här. Du lämnar dina uppgifter på
            Verisures sida.
          </p>
        </div>
        <div className="flex flex-wrap gap-4 mb-6" data-id="element-138">
          <a href="#" className="text-sm text-gray-400 hover:text-white" data-id="element-139">
            Cookies & Integritet
          </a>
          <a href="#" className="text-sm text-gray-400 hover:text-white" data-id="element-140">
            Ansvarsfriskrivning
          </a>
        </div>
        <p className="text-xs text-gray-500" data-id="element-141">
          Varje hem är unikt; informationen här är generell. Kontrollera alltid
          de senaste råden från Brå, MSB och Polisen.
        </p>
      </div>
    </footer>;
}